var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconChevron = function SvgIconChevron(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-232.000000, -84.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DSC-/-Icons-/-arrow-1",
    transform: "translate(232.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.961045,4.77903944 C10.9583001,4.4743804 10.8375373,4.183446 10.6243696,3.96661533 L5.00335411,-1.65440017 C4.54592055,-2.11366056 3.8039465,-2.11551081 3.34559953,-1.65806086 C2.88633914,-1.20154072 2.88448889,-0.459566671 3.34194119,-0.000306283582 L8.13596478,4.79371731 L3.34194119,9.58774091 C2.88450763,10.0460879 2.88633446,10.7880619 3.34559953,11.2454955 C3.8039465,11.7020156 4.54592055,11.7001888 5.00335411,11.2418371 L10.6243696,5.62082164 C10.8448563,5.39667662 10.9656121,5.09293802 10.961045,4.77912141 L10.961045,4.77903944 Z",
    id: "Fill-1",
    transform: "translate(6.980585, 4.793373) rotate(90.000000) translate(-6.980585, -4.793373) "
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_chevron.505232aa.svg";
export { ForwardRef as ReactComponent };